import { Icon } from '@acast-tech/decibel';
import { CircleInfoLightGlyph } from '@acast-tech/decibel-glyphs';
import type { LaunchWindowDays } from '@/types/content';

interface LaunchInfoBoxProps {
  windowDays: LaunchWindowDays;
}

/** Informational banner explaining what the launch-window metrics represent. */
const LaunchInfoBox = ({ windowDays }: LaunchInfoBoxProps) => (
  <div className="flex items-start gap-3 rounded-lg border border-[#B1B1B1] bg-[#FAFAFA] p-4 my-6 text-sm text-textDarkGrey">
    <Icon glyph={CircleInfoLightGlyph} className="mt-0.5 shrink-0 text-textDarkGrey" />
    <p className="translate-y-1">
      Figures reflect each episode&apos;s totals in the first {windowDays} days of publication,
      allowing to compare performance at the same stage of the lifecycle.{' '}
      <a
        href="https://learn.acast.com/en/articles/15503008-content-performance-tab-post-launch-comparison-tab"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Learn more (opens in new tab)"
        className="font-medium text-[#00749E] underline hover:text-[#00749E]/80"
      >
        Learn more
      </a>
    </p>
  </div>
);

export default LaunchInfoBox;
